import { render } from "./ProjectCategoryDetail.vue?vue&type=template&id=36b6e3ec"
import script from "./ProjectCategoryDetail.vue?vue&type=script&lang=js"
export * from "./ProjectCategoryDetail.vue?vue&type=script&lang=js"

import "./ProjectCategoryDetail.vue?vue&type=style&index=0&id=36b6e3ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__